import React from 'react';
import { useLocation } from '@scentregroup/shared/next/compat/location';
import { CoreContainer } from '@hub/core-container';
import { EmbeddedSearch } from '../../components/search';
import { useCountryContext } from '../../context';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchResultsPage = _ref => {
  let {
    centre,
    centres = [],
    algoliaResults
  } = _ref;
  const {
    search
  } = useLocation();
  const showFixedQuery = new URLSearchParams(search).get('q') || '';
  const country = useCountryContext();
  return /*#__PURE__*/_jsx(CoreContainer, {
    "data-id": "search-results_index_SearchResultsPage_CoreContainer",
    children: /*#__PURE__*/_jsx(EmbeddedSearch, {
      algoliaResults: algoliaResults,
      country: country,
      showFixedQuery: showFixedQuery,
      centre: centre,
      centres: centres,
      "data-id": "search-results_index_SearchResultsPage_CoreContainer_EmbeddedSearch"
    })
  });
};
export default SearchResultsPage;